jQuery(document).ready(function($){
	
	// //open search-box on click, search-icon
	// $('.search-icon').click(function(e) {
	// 	e.stopPropagation(); // Prevent click from bubbling up
	// 	const searchContainer = $('.search-input-item');
		
    //     if (!searchContainer.hasClass('expanded')) {
    //         searchContainer.addClass('expanded').find('input').focus();
    //     } else {
    //         searchContainer.removeClass('expanded');
    //     }
    // });

    // // Close search input when clicking outside
    // $(document).click(function (e) {
    //     if (!$(e.target).closest('.search-bar').length) {
    //         $('.search-input-item').removeClass('expanded');
    //     }
    // });

$(".search-icon").click(function(){
  $(".utility-search").toggle();
});
	

  	//open menu on hover for desktop
	  if ($(window).width() >= 768) { 
	
		$('.menu-item-has-children').hover(
            function() {
                // Show dropdown menu
                $(this).children('.dropdown-menu').addClass('show');
            },
            function() {
                // Hide dropdown menu
                $(this).children('.dropdown-menu').removeClass('show');
            }
        );
	}
	else{
		$('#menuToggle, #navbarNavDropdown').off('mouseenter mouseleave');
        $('.menu-item-has-children').off('mouseenter mouseleave');
	}

		
	//add dropdown menu toggle functionality to down arrow
	$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	})

  	$('.region-content').hide();
  	$('#region-1.region-content').show();
  	$('.region-1').css('fill', '#82FFFF');
  	$('.region-1').css('stroke-width', '4');


  	$('.region').click(function(e){
  		$('.region-content').hide();
  		$('.region').css('fill', '#EDEBF5');
  		$('.region').css('stroke-width', '2');

  		$( this ).css('fill', '#82FFFF');
  		$( this ).css('stroke-width', '4');

  		var classes = $( this ).attr('class');
  		$( '#' + classes.replace('region ', '') ).show();
  	})

  	$('.number').click(function(e){
  		var currentRegion = $( this ).attr('class').slice(-1);
  		$('.region-content').hide();
  		$('.region').css('fill', '#EDEBF5');
  		$('.region').css('stroke-width', '2');

  		$( '.region-' + currentRegion ).css('fill', '#82FFFF');
  		$( '.region-' + currentRegion ).css('stroke-width', '4');

  		$( '#region-' + currentRegion ).show();

  	})
  
	// Get the button:
	let mybutton = document.getElementById("btt");
	//let mybutton = $('#btt')[0];

	// Check if the button exists before adding the event listener
	if (mybutton) {
	// When the user scrolls down 20px from the top of the document, show the button
	window.addEventListener('scroll', scrollFunction);

	function scrollFunction() {
		if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
		mybutton.style.display = "block";
		} else {
		mybutton.style.display = "none";
		}
	}
	} else {
	console.error("Button with id 'btt' not found.");
	}

	// When the user clicks on the button, scroll to the top of the document
	$('#btt').click(function(){
	
	  document.body.scrollTop = 0; // For Safari
	  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	});

  // play/pause functionality for full width videos
	$('.block-video-full.new-vid').click (function (e) {
		e.preventDefault(); // <=====================
		var videoBlock = $(this);

		if (videoBlock.hasClass('video-file')) {
			var video = videoBlock;
		} else {
			var video = videoBlock.find('video');
		}
		
		
		video.trigger('play');
		videoBlock.removeClass('new-vid');
		video.attr('controls', true);

	})
	$(document).on('facetwp-loaded', function() {
	    $('.facetwp-facet-search .facetwp-icon').hide();
	    $('.facetwp-facet-search .facetwp-input-wrap').each(function() {
	        if ($(this).find('.facetwp-search-submit').length < 1) {
	            $(this).find('.facetwp-search').after('<button class="facetwp-search-submit" onclick="FWP.refresh()">Search</button>');
	        }
	    });
	});

	 $('.video-slider').slick({
        dots: false,
        arrows: true,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        adaptiveHeight: true
    });

    // Play button overlay for HTML5 video
    $('.play-button-overlay-file').on('click', function () {
	    const wrapper = $(this).closest('.video-wrapper');
	    const video = wrapper.find('video').get(0);

	    // Add controls before playing
	    video.setAttribute('controls', true);
	    video.play();
	    
	    $(this).fadeOut();
	});
	$('.video-slider').on('beforeChange', function () {
	    $('.video-player').each(function () {
	        this.pause();
	        this.removeAttribute('controls');
	        this.currentTime = 0; // optional: reset to beginning
	    });

	    // Also show the play buttons again
	    $('.play-button-overlay').fadeIn();
	});
});

document.addEventListener("DOMContentLoaded", function(event) {


	window.addEventListener("load", function(e) {
    
    gsap.registerPlugin(ScrollTrigger);

    let fade = gsap.utils.toArray('.fade');

    fade.forEach((text, i) => {
    	gsap.to(text, {
    		stagger: 0.5,
				opacity: 1,
				y: 0,
				ease: "back.out(1.7)",
				scrollTrigger: {
					start: 'top 75%',
					trigger: text
				}
			});
    });

    var animationScoll;

	if (window.matchMedia("(min-width: 992px)").matches) {
	  animationScoll = 540;
	} else {
	  animationScoll = 120;
	}

    gsap.to(".scrub-animation", {
    	scrollTrigger: {
    		trigger: ".scrub-animation",
    		start: "top center",
    		end: "bottom 100px",
    		scrub: 2,
    		markers: false
    	},
    	y: animationScoll,
    	duration: 3
    });
    gsap.timeline()
  	.to('.img-fluid', {duration:0.1, scale:1.1, stagger:0.1, ease: 'power1.in'}, 0)
  	.to('.img-fluid', {duration:0.05, scale:1, stagger:0.1, ease: 'power1.out'}, .25)
  	.to('.img-accents', {duration:0.05, scale: 1.1, stagger:0.05, ease: 'power1.in'}, 0)
  	.to('.img-accents', {duration:0.05, scale: 1, stagger:0.05, ease: 'power1.out'}, .25)
  	.from('.img-accents', {duration:0.25, x:-20, y:20, stagger:0.05, ease: 'power1.in'}, 0)
    // .from('.img-accents.tl', {duration:0.3, x:-30, y:-30, stagger: 0.01, ease: 'expo.in'}, 0)
    // .from('.img-accents.bl', {duration:0.3, x:-30, y:30, stagger: 0.01, ease: 'expo.in'}, 0)
    // .from('.img-accents.tr', {duration:0.05, x:30, y:30, stagger: 0.01, ease: 'expo.in'}, 0)
    // .from('.img-accents.br', {duration:0.05, x:30, y:-30, stagger: 0.01, ease: 'expo.in'}, 0)


  }, false);
 
});